/**
 * AKLE — Quick add al carrito + confirmación visual
 * Maneja formularios [data-akle-quick-add] con delegación (incluye contenido cargado por fetch).
 */
(function () {
  'use strict';

  function showAlert(message, type, header) {
    window.dispatchEvent(
      new CustomEvent('showAlert', {
        detail: {
          message: message,
          type: type || 'success',
          header: header || undefined,
          origin: 'akle-cart'
        }
      })
    );
  }

  function getCartSectionKeys() {
    var sections = ['side-cart'];

    if (window.general && window.general.template === 'cart') {
      var cartForm = document.querySelector('.akle-cart-page__form, form.form-cart');
      if (cartForm) {
        var cartSection = cartForm.closest('[id^="shopify-section-"]');
        if (cartSection) {
          sections.push(cartSection.id.replace('shopify-section-', ''));
        }
      }
    }

    return sections.join(',');
  }

  function updateCartPageFromResponse(response) {
    if (!response || !response.sections || !window.general || window.general.template !== 'cart') {
      return;
    }

    var cartForm = document.querySelector('.akle-cart-page__form, form.form-cart');
    if (!cartForm) return;

    var container = cartForm.closest('[id^="shopify-section-"]');
    if (!container) return;

    var sectionKey = container.id.replace('shopify-section-', '');
    var sectionHtml = response.sections[sectionKey];
    if (!sectionHtml) return;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var updated = parsed.querySelector('#shopify-section-' + sectionKey);
    if (!updated) return;

    container.innerHTML = updated.innerHTML;
    window.dispatchEvent(new CustomEvent('listCart'));
    if (typeof ajaxCart !== 'undefined' && ajaxCart.init) {
      ajaxCart.init();
    }
  }

  function refreshCartWithResponse(response, openDrawer) {
    if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
      ajaxCart.load(response, openDrawer !== false);
    }
    updateCartPageFromResponse(response);
  }

  function refreshCartFallback(openDrawer) {
    if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
      fetch(window.Shopify.routes.root + '?section_id=side-cart')
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var section = parsed.querySelector('#shopify-section-side-cart');
          if (!section) return;
          ajaxCart.load({ sections: { 'side-cart': section.outerHTML } }, openDrawer !== false);
        })
        .catch(function () {
          ajaxCart.load(false, openDrawer !== false);
        });
      return;
    }
    window.dispatchEvent(new CustomEvent('ajaxCart'));
  }

  function getVariantIdFromForm(form) {
    var input = form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function getQuantityFromForm(form) {
    var input = form.querySelector('input[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function addVariantToCart(form, variantId, quantity, openDrawer) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity || 1));
    formData.append('sections', getCartSectionKeys());

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript'
      }
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          var err = new Error(data.description || data.message || 'Error al agregar al carrito');
          err.payload = data;
          throw err;
        }
        refreshCartWithResponse(data, openDrawer);
        return data;
      });
    });
  }

  function shouldOpenDrawer(form) {
    return !form.closest('.template-cart, .akle-cart-page');
  }

  function processQuickAddForm(form) {
    if (!form || form.classList.contains('akle-quick-add--busy')) return;

    var variantId = getVariantIdFromForm(form);
    if (!variantId) {
      showAlert('No se pudo agregar el producto. Intentá de nuevo.', 'error', 'Error');
      return;
    }

    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    form.classList.add('akle-quick-add--busy');

    addVariantToCart(form, variantId, getQuantityFromForm(form), shouldOpenDrawer(form))
      .then(function () {
        showAlert('El producto se agregó correctamente a tu carrito.', 'success', 'Agregado al carrito');
      })
      .catch(function (error) {
        var message =
          (error && error.payload && error.payload.description) ||
          (error && error.message) ||
          'No se pudo agregar el producto. Intentá de nuevo.';
        showAlert(message, 'error', 'Error');
      })
      .finally(function () {
        form.classList.remove('akle-quick-add--busy');
        if (button) button.disabled = false;
      });
  }

  function handleQuickAddSubmit(event) {
    var form = event.target.closest('[data-akle-quick-add]');
    if (!form || form.classList.contains('akle-quick-add--busy')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    processQuickAddForm(form);
  }

  function handleQuickAddClick(event) {
    var button = event.target.closest('[data-akle-quick-add] .akle-cart-upsell__add-btn');
    if (!button) return;
    var form = button.closest('[data-akle-quick-add]');
    if (!form || form.classList.contains('akle-quick-add--busy')) return;
    event.preventDefault();
    event.stopPropagation();
    processQuickAddForm(form);
  }

  document.addEventListener('submit', handleQuickAddSubmit, true);
  document.addEventListener('click', handleQuickAddClick, true);

  var lastMainFormSubmit = 0;
  document.addEventListener(
    'submit',
    function (event) {
      if (event.target.closest('.akle-product-main__form')) {
        lastMainFormSubmit = Date.now();
      }
    },
    true
  );

  window.addEventListener('listCart', function () {
    if (Date.now() - lastMainFormSubmit > 5000) return;
    lastMainFormSubmit = 0;
    showAlert('El producto se agregó correctamente a tu carrito.', 'success', 'Agregado al carrito');
  });

  document.addEventListener(
    'akle:cart-content-updated',
    function () {
      refreshCartFallback(false);
    }
  );

  window.AkleCartFeedback = {
    refresh: refreshCartFallback,
    notify: showAlert
  };
})();
